import { AccountSubscriptionTypes } from '@nizza/core';
import { useEffect, useState } from 'react';
import { buildPostMessage, SubscriptionActionsEvents } from 'shared';
import { ExternalCreateSubs, ExternalSubscriptionInfo } from 'types';

const postMessage = buildPostMessage<SubscriptionActionsEvents>(window.parent);

interface Props {
  planId: AccountSubscriptionTypes;
  planPrice: string;
}
export const useExternalPayButton = ({ planId, planPrice }: Props) => {
  const [subscription, setSubscription] = useState<ExternalSubscriptionInfo>();
  const [wasSelected, setWasSelected] = useState(false);

  const handlerSubscription = (action: SubscriptionActionsEvents) => {
    const payload: ExternalCreateSubs = {
      name: planId,
      amount: Number.parseFloat(planPrice),
    };

    postMessage(action, payload);
  };

  const cancelSubscription = () => {
    const { CANCEL_SUBSCRIPTION } = SubscriptionActionsEvents;
    handlerSubscription(CANCEL_SUBSCRIPTION);
  };

  const createOrUpdateSubscription = () => {
    const { UPDATE_SUBSCRIPTION, CREATE_SUBSCRIPTION } =
      SubscriptionActionsEvents;

    const action =
      subscription?.status === 'active'
        ? UPDATE_SUBSCRIPTION
        : CREATE_SUBSCRIPTION;

    handlerSubscription(action);
  };

  useEffect(() => {
    postMessage(
      SubscriptionActionsEvents.SEND_SUBSCRIPTION,
      'notifySendSubscription',
    );
  }, []);

  useEffect(() => {
    const handleMessages = (event: MessageEvent<any>) => {
      const data = event.data;

      if (
        !data?.source?.includes('Nizza') ||
        data?.target !== 'ExternalPayButton'
      )
        return;

      if (
        data?.name === SubscriptionActionsEvents.SEND_SUBSCRIPTION &&
        data?.payload
      )
        setSubscription(data?.payload);
    };

    window.addEventListener('message', handleMessages, false);

    return () => {
      window.removeEventListener('message', handleMessages);
    };
  }, []);

  useEffect(() => {
    if (!subscription || !planId) return;
    const isActive =
      subscription.status === 'active' &&
      subscription.name.toLowerCase() === planId;

    setWasSelected(isActive);
  }, [subscription, planId]);

  return {
    cancelSubscription,
    createOrUpdateSubscription,
    subscription,
    wasSelected,
  };
};
